import { useTranslation } from 'react-i18next';
import {
  ACCOUNT_TYPE_CORPORATE_TRUST,
  ACCOUNT_TYPE_IRA_ROTH,
  ACCOUNT_TYPE_IRA_SEP,
  ACCOUNT_TYPE_IRA_SIMPLE,
  ACCOUNT_TYPE_IRA_TRADITIONAL,
} from '../constants/accountTypes';
import { ACCOUNT_TYPE, APPLICATION_TYPE } from '../constants/sessionStorage';
import { APPLICATION_TYPE_STRING } from '../util/constants';

import { retrieveFromSessionStorage } from '../util/helpers/sessionStorageHelper';

export const useAgreement = () => {
  const ApplicationType = retrieveFromSessionStorage(APPLICATION_TYPE);
  const AccountType = retrieveFromSessionStorage(ACCOUNT_TYPE);
  const { t } = useTranslation();
  const defaultAgreement = {
    title: '',
    acknowledge: t('agreement.acknowledge'),
    download: '',
  };

  switch (ApplicationType) {
    case APPLICATION_TYPE_STRING[1]:
      return {
        ...defaultAgreement,
        title: t('agreement.title'),
      };

    case APPLICATION_TYPE_STRING[2]: {
      switch (AccountType) {
        case ACCOUNT_TYPE_CORPORATE_TRUST:
          return {
            ...defaultAgreement,
            title: t('agreement.trustTitle'),
          };

        default:
          return {
            ...defaultAgreement,
            title: t('agreement.businessTitle'),
          };
      }
    }

    case APPLICATION_TYPE_STRING[3]: {
      switch (AccountType) {
        case ACCOUNT_TYPE_IRA_TRADITIONAL:
          return {
            ...defaultAgreement,
            title: t('agreement.iraTraditionalTitle'),
          };
        case ACCOUNT_TYPE_IRA_ROTH:
          return {
            ...defaultAgreement,
            title: t('agreement.iraRothTitle'),
          };
        case ACCOUNT_TYPE_IRA_SEP:
          return {
            ...defaultAgreement,
            title: t('agreement.iraSepTitle'),
          };
        case ACCOUNT_TYPE_IRA_SIMPLE:
          return {
            ...defaultAgreement,
            title: t('agreement.iraSimpleTitle'),
          };

        default:
          return defaultAgreement;
      }
    }

    case APPLICATION_TYPE_STRING[4]: {
      return {
        ...defaultAgreement,
        title: t('agreement.jointTitle'),
      };
    }

    case APPLICATION_TYPE_STRING[5]: {
      return {
        ...defaultAgreement,
        title: t('agreement.utmaTitle'),
      };
    }

    default:
      return defaultAgreement;
  }
};
